import axios from "~/axios";
import getConfig from "~/config";

export default async function fetchQR(error) {
    let {basePublicUrl} = getConfig();
    return await axios.post(`${basePublicUrl}/api/admin/getauthqrcodeurl`);
}